import { LocaleDateFormat } from 'core/enums/LocaleDateFormat';

export const localeMap: { [key in LocaleDateFormat]: { dateFormat: string; mask: string; dateAndTimeFormat: string } } =
  {
    [LocaleDateFormat.DE]: {
      dateFormat: 'DD.MM.yyyy',
      dateAndTimeFormat: 'DD.MM.yyyy - HH:mm:ss',
      mask: '__.__.____',
    },
    [LocaleDateFormat.EN]: {
      dateFormat: 'DD/MM/yyyy',
      dateAndTimeFormat: 'DD/MM/yyyy - HH:mm:ss',
      mask: '__/__/____',
    },
    [LocaleDateFormat.US]: {
      dateFormat: 'MM/DD/yyyy',
      dateAndTimeFormat: 'MM/DD/yyyy - hh:mm:ss a',
      mask: '__/__/____',
    },
  };

export const getFormat = (locale: LocaleDateFormat) => localeMap[locale].dateFormat;

export const getMask = (locale: LocaleDateFormat) => localeMap[locale].mask;
